import { createSelector } from '@ngrx/store';

import * as fromCore from '@core/core-store/core.reducer';
import * as fromContent from './content-details.reducer';

export const selectState = createSelector(
  fromCore.selectState,
  fromCore.getContentDetails
);

export const selectAll = createSelector(
  selectState,
  fromContent.getAll
);

export const selectEntities = createSelector(
  selectState,
  fromContent.getEntities
);

export const selectIds = createSelector(
  selectState,
  fromContent.getIds
);

export const selectTotal = createSelector(
  selectState,
  fromContent.getTotal
);

export const selectEntityById = createSelector(
  selectEntities,
  fromContent.getEntityById
);

export const selectEntitiesById = createSelector(
  selectEntities,
  fromContent.getEntitiesById
);
